var _excluded = ["locality"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SuburbSummary from './suburb-summary';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment SuburbSummary on Locality {\n    ... on ResearchLocality {\n      statistics {\n        houseMedianPrice\n        unitMedianPrice\n        unitPriceYearlyDelta\n        housePriceYearlyDelta\n      }\n    }\n    ... on Division {\n      name\n      profile {\n        url\n        census {\n          medianAge\n          population\n          homeOwnership {\n            fullyOwn\n            purchasing\n            rentFromGovernment\n            rentPrivate\n            other\n          }\n          dwellingTypes {\n            house\n            townhouse\n            unit\n            other\n          }\n        }\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _profile$census, _profile$census2, _profile$census3, _profile$census4;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    division = _ref.division;
  var _ref2 = division || {},
    profile = _ref2.profile;
  return {
    suburbName: division.name,
    medianStatistics: division.statistics,
    averageAge: profile && (profile === null || profile === void 0 ? void 0 : (_profile$census = profile.census) === null || _profile$census === void 0 ? void 0 : _profile$census.medianAge) !== '0 years' ? "".concat(profile.census.medianAge) : null,
    population: profile && (profile === null || profile === void 0 ? void 0 : (_profile$census2 = profile.census) === null || _profile$census2 === void 0 ? void 0 : _profile$census2.population) !== '0' ? "".concat(profile.census.population) : null,
    suburbInfoLink: profile === null || profile === void 0 ? void 0 : profile.url,
    profileData: profile !== null && profile !== void 0 && (_profile$census3 = profile.census) !== null && _profile$census3 !== void 0 && _profile$census3.dwellingTypes ? [{
      value: profile.census.dwellingTypes.house,
      label: 'Houses'
    }, {
      value: profile.census.dwellingTypes.townhouse,
      label: 'Townhouses'
    }, {
      value: profile.census.dwellingTypes.unit,
      label: 'Flats & Units'
    }, {
      value: profile.census.dwellingTypes.other,
      label: 'Other'
    }] : null,
    occupancyData: profile !== null && profile !== void 0 && (_profile$census4 = profile.census) !== null && _profile$census4 !== void 0 && _profile$census4.homeOwnership ? [{
      value: profile.census.homeOwnership.fullyOwn,
      label: 'Fully Own'
    }, {
      value: profile.census.homeOwnership.purchasing,
      label: 'Purchasing'
    }, {
      value: profile.census.homeOwnership.rentFromGovernment,
      label: 'Rent from Gov.'
    }, {
      value: profile.census.homeOwnership.rentPrivate,
      label: 'Rent Private'
    }, {
      value: profile.census.homeOwnership.other,
      label: 'Other'
    }] : null
  };
};
var SuburbSummaryGraphQL = _ref3 => {
  var locality = _ref3.locality,
    props = _objectWithoutProperties(_ref3, _excluded);
  return ___EmotionJSX(SuburbSummary, _extends({}, graphQLToProps({
    division: locality
  }), props));
};
SuburbSummaryGraphQL.fragment = fragment;
SuburbSummaryGraphQL.graphQLToProps = graphQLToProps;
SuburbSummaryGraphQL.propTypes = {
  locality: PropTypes.shape({
    name: PropTypes.string,
    profile: PropTypes.shape({
      infoLink: PropTypes.string,
      census: PropTypes.shape({
        medianAge: PropTypes.string,
        population: PropTypes.string,
        homeOwnership: PropTypes.shape({
          fullyOwn: PropTypes.number,
          purchasing: PropTypes.number,
          rentFromGovernment: PropTypes.number,
          rentPrivate: PropTypes.number,
          other: PropTypes.number
        }),
        dwellingTypes: PropTypes.shape({
          house: PropTypes.number,
          townhouse: PropTypes.number,
          unit: PropTypes.number,
          other: PropTypes.number
        })
      })
    })
  }).isRequired
};
export default SuburbSummaryGraphQL;